import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="#08311d"
					image={require('./image.jpg')}
					title={"The 2020 Changes to Facebook's Algorithm All Business Owners Should Know About"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle lauren"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Lauren</strong> on 27 Feb 2020  //  Posted in <strong>Marketing, Advertising</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
								<p>While there haven’t been any drastic changes to Facebook’s algorithm in 2020 (yet!), there are still a few changes that business owners should be aware of in order to create top ranking content. </p>
								</div>



<p>These aren’t dissimilar to Instagram’s algorithm hierarchy factors either - given that Facebook owns Instagram, this isn’t that surprising.</p>
<p>In case you’re wondering what the Facebook algorithm is, it is essentially the method by which Facebook decides what posts are seen in your feed, at what time and how frequently your business posts are shown. </p>

<br></br>
<hr></hr>

<h2>1. Prioritising Authentic Posts Over 'Spammy' Posts</h2>
<p>Much like Instagram, Facebook is getting increasingly better at filtering authentic, engaging posts from inauthentic, salesy, misleading posts. This isn’t exactly new - social platforms have been pushing for authentic, human connection over mechanical, scheduled posts for months now. However, this has been primarily highlighted on Instagram, not so much Facebook.</p>
<h4>What this means for you:</h4>
<p>
This latest Facebook update is requesting you to post conversation-starting material.</p>
<p>Ask questions! Get your audience engaged in what you have to say.</p>

<br></br>
<hr></hr>

<h2>2. Limiting Ads Per Page</h2>
<p>If you’re a Facebook Business Page owner, you’ll be familiar with the Ads Manager side of Facebook, and hopefully have run some campaigns in your time - if this is something you’d like to learn about, the team here at Moshi Moshi Marketing can always help you out! 
</p>
<p>From early 2020 Facebook is implementing a limit to the amount of ads a Business Page can create. Whilst this Facebook change is aimed at targeting larger companies and businesses (primarily larger global companies), it still gives us a useful insight as to what’s being prioritised. </p>

<h4>What this means for you:</h4>
<p>It’s important that you prioritise your campaigns this year for a seamless, high ranking strategy.</p>
<p>Invest more into your campaigns that you’re expecting to perform well, and consider dropping the smaller ones you’re not expecting a high ROI on. Facebook reads this as <b>high spend + high engagement = higher placement, vs less spend + less engagement = lower placement</b>, which ultimately means a waste of money on your behalf. </p>

<br></br>
<hr></hr>

<h2>3. Facebook Video is Still The Most Engaging Form of Post</h2>
<p>While video was often the hardest form of post to capture user data from, changes to the Creator Studio in Facebook’s backend means that it’s now easy to see the duration of time someone spent watching a video, their demographic data, and how often they engage with your page. </p>

<h4>What this means for you:</h4>
<p>Keep going with Facebook video! Facebook Live is generating 6x more interaction as regular videos, but if that’s not your comfort zone, aim for videos of quality, relatable content over 3 minutes long.</p>

<br></br>
<hr></hr>

<h3>And Remember, Don’t Post Anything That’s Not on Brand!</h3>
<p>These new Facebook changes don’t mean anything if you’re not posting in a consistent tone across your platforms. If your tone, or ‘brand voice’ is something you’re struggling to find, Moshi Moshi can help you out. Alternatively, give it a go yourself by following <a href="https://www.moshi.com.au/blog/establishing-a-voice-for-your-brand">these steps</a>. 
</p>


							




							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/The2020ChangesToFacebooksAlgorithm/index.js